export default __webpack_public_path__ + "static/media/trampapo_02_27.bb1d64bb.jpg";